import React from "react";
import { formatNumber2 } from "../../../../utils/currencyFormat"
import { getDate } from "../../../../utils/formatDate";
import { BtnChiTietHopDong } from "../ChiTietKhachHangVaHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachHang } from "../ChiTietKhachHangVaHopDong/BtnChiTietKhacHang";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const tinhTrangStyleMap = {
    'Nợ xấu': { color: '#c0392b'},
    'Nợ rủi ro': { color: '#dd6308' },
    'Nợ R2': { color: '#fd7e14' },
    'Nợ R3': { color: '#dc3545' },
};

const TooltipLink = ({ id, content, children }) => {
    if (!content) {
        return null;
    }
    const renderTooltip = (props) => (
        <Tooltip id={id} {...props} style={{ whiteSpace: 'pre-wrap', ...props.style }}>
            {content.replace(/\|/g, '\n')}
        </Tooltip>
    );
    return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
            <a href="#!" onClick={e => e.preventDefault()} className="text-danger" style={{ fontSize: '0.85em', textDecoration: 'none' }}>
                {children}
            </a>
        </OverlayTrigger>
    );
};

export const ContentTable = ({ listHopDong, selectedHopDong, setSelectedHopDong, onOpenModalHopDong, onOpenModalKhachHang }) => {
    if (!listHopDong || listHopDong.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <div className="custom-table-cell text-center red" style={{ width: "100%", border: 'none' }}>
                    Không có dữ liệu
                </div>
            </div>
        );
    }

    return (
        <>
            {listHopDong.map((item) => {
                let statusStyle = {};
                if (item.TinhTrang && item.TinhTrang.startsWith('Bình thường')) {
                    statusStyle = { color: '#006266' }; 
                } else {
                    statusStyle = tinhTrangStyleMap[item.TinhTrang] || {};
                }

                const isSelected = selectedHopDong?.ChoVayID === item.ChoVayID;

                return (
                    <div
                        key={item.ChoVayID}
                        className={`custom-table-row ${isSelected ? 'active-row' : ''}`}
                        style={{ 
                            minHeight: "56px", 
                            borderBottom: '1px solid #e0e0e0',
                            cursor: 'pointer',
                            backgroundColor: isSelected ? '#e3f2fd' : ''
                        }}
                        onClick={() => setSelectedHopDong(item)}
                    >
                        <div className="custom-table-cell flex-basis-5 flex-basis-5-sm">
                            <span className="mobile-column-name color7-bold">STT</span>
                            <div className="center-wrapper word-break" style={{justifyContent: 'center'}}>
                                {item.STT}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-12 flex-basis-12-sm">
                            <span className="mobile-column-name color7-bold">Mã hợp đồng</span>
                            <div className="center-wrapper word-break">
                                <BtnChiTietHopDong item={item} onOpenModalHopDong={onOpenModalHopDong} />
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-15 flex-basis-15-sm">
                            <span className="mobile-column-name color7-bold">Tên khách hàng</span>
                            <div className="center-wrapper word-break">
                                <BtnChiTietKhachHang item={item} onOpenModalKhachHang={onOpenModalKhachHang}/>
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name color7-bold">Thời gian vay</span>
                            <div className="center-wrapper word-break" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                {item.NgayVay ? getDate(item.NgayVay) : ''}
                                {item.NgayVay && item.NgayTra && <br />}
                                {item.NgayTra ? getDate(item.NgayTra) : ''}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
                            <span className="mobile-column-name color7-bold">Số tiền vay</span>
                            <div className="center-wrapper word-break text-right" style={{display: "flex", flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                <span className="red">{formatNumber2(item.SoTienVay)}</span>
                                <small style={{ color: '#dd6308' }}>{item.LaiSuat}</small>
                            </div>
                        </div>

                        <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
                            <span className="mobile-column-name color7-bold">Số tiền đã trả</span>
                            <div className="center-wrapper red word-break text-right" style={{justifyContent: 'flex-end'}}>
                                {formatNumber2(item.SoTienDaTra)}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
                            <span className="mobile-column-name color7-bold">Số tiền thanh toán</span>
                            <div className="center-wrapper red word-break text-right" style={{justifyContent: 'flex-end'}}>
                                {formatNumber2(item.SoTienThanhToan)}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-13 flex-basis-13-sm">
                            <span className="mobile-column-name color7-bold">Quá hạn</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                <b>{item.QuaHan} Ngày</b>
                                {(item.FilteredNotes || item.FilteredExtensions) && (
                                    <div style={{ marginTop: '1px', marginLeft: '5px' }}>
                                        <TooltipLink id={`note-${item.ChoVayID}`} content={item.FilteredNotes}>
                                            Ghi chú
                                        </TooltipLink>
                                        {item.FilteredNotes && item.FilteredExtensions && <span>-</span>}
                                        <TooltipLink id={`ext-${item.ChoVayID}`} content={item.FilteredExtensions}>
                                            Gia hạn
                                        </TooltipLink>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-9 flex-basis-9-sm">
                            <span className="mobile-column-name color7-bold">Tình trạng</span>
                            <div className="center-wrapper word-break" style={statusStyle}>
                                <b>{item.TinhTrang}</b>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};